<div class="login-wrapper">
  <div class="login-content">
    <button class="arrow-btn" routerLink="/sign-up"><img src="assets/images/booking/left-arrow.svg" alt="left arrow" loading="lazy"></button>
    <h2 class="title">Welcome!</h2>
    <p class="subtitle">Australia's only dedicated wellbeing marketplace.</p>
    <form [formGroup]="signUpForm" class="login-form" (submit)="signUpUser()">
      <div class="field-type-1" [ngClass]="{'invalid': signUpForm.controls['first_name'].dirty && signUpForm.controls['first_name'].errors}">
        <label for="" class="field-label">First name <span class="field-mandatory">*</span></label>
        <input type="text" formControlName="first_name" class="field-input" autocomplete="first_name">
        <ul *ngIf="signUpForm.controls['first_name'].dirty && signUpForm.controls['first_name'].errors">
          <ng-container *ngIf="signUpForm.controls['first_name'].errors['alphanumeric']; else nameNormalElse">
            <li class="error-message">Enter valid First name.</li>
          </ng-container>
          <ng-template #nameNormalElse>
            <ng-container *ngIf="signUpForm.controls['first_name'].errors['required']">
              <li class="error-message">First name is required.</li>
            </ng-container>
            <ng-container *ngIf="signUpForm.controls['first_name'].errors['minlength']">
              <li class="error-message">First name should have minimum of 2 characters.</li>
            </ng-container>
          </ng-template>
        </ul>
      </div>
      <div class="field-type-1" [ngClass]="{'invalid': signUpForm.controls['last_name'].dirty && signUpForm.controls['last_name'].errors}">
        <label for="" class="field-label">Last name <span class="field-mandatory">*</span></label>
        <input type="text" formControlName="last_name" class="field-input" autocomplete="last_name">
        <ul *ngIf="signUpForm.controls['last_name'].dirty && signUpForm.controls['last_name'].errors">
          <ng-container *ngIf="signUpForm.controls['last_name'].errors['alphanumeric']; else nameNormalElse">
            <li class="error-message">Enter valid First name.</li>
          </ng-container>
          <ng-template #nameNormalElse>
            <ng-container *ngIf="signUpForm.controls['last_name'].errors['required']">
              <li class="error-message">First name is required.</li>
            </ng-container>
            <ng-container *ngIf="signUpForm.controls['last_name'].errors['minlength']">
              <li class="error-message">First name should have minimum of 2 characters.</li>
            </ng-container>
          </ng-template>
        </ul>
      </div>
      <div class="field-type-1" [ngClass]="{'invalid': signUpForm.controls['email'].dirty && signUpForm.controls['email'].errors}">
        <label for="" class="field-label">Email <span class="field-mandatory">*</span></label>
        <input type="email" formControlName="email" class="field-input" autocomplete="email">
        <ng-container *ngIf="signUpForm.controls['email'].dirty && signUpForm.controls['email'].errors">
          <ng-container *ngIf="signUpForm.controls['email'].errors['required']">
            <li class="error-message">Email is required.</li>
          </ng-container>
          <ng-container *ngIf="signUpForm.controls['email'].errors['pattern']">
            <li class="error-message">Invalid email.</li>
          </ng-container>
        </ng-container>
      </div>
      <app-tel-input label="Phone" [required]="true" [showErrorLabel]="true" [value]="phoneObject" (phoneGroupEmit)="phoneGroupEmit($event)"></app-tel-input>
      <div class="field-type-1" [ngClass]="{invalid: signUpForm.controls['password'].dirty && signUpForm.controls['password'].errors}">
        <label for="" class="field-label">Password <span class="field-mandatory">*</span></label>
        <input [type]="hidePassword ? 'password' : 'text'" class="field-input" formControlName="password" />
        <img [src]="hidePassword ? 'assets/images/view.svg' : 'assets/images/hide.svg'" alt="hide" class="show-password" (click)="showPasswordToggle()" />
        <ng-container *ngIf="signUpForm.controls['password'].dirty && signUpForm.controls['password'].errors">
          <p [ngClass]="{ 'success-message': passwordMinLengthCheck() }" class="error-message">
            <img [src]="passwordMinLengthCheck() ? 'assets/images/circle-checked-fill.svg' : 'assets/images/close-circle-fill.svg'" alt="hide" class="valid-icons" />
            <span class="msg">Password must be at least 8 characters long.</span>
          </p>
          <p [ngClass]="{ 'success-message': !checkPasswordError('uppercase') }" class="error-message">
            <img [src]=" !checkPasswordError('uppercase') ? 'assets/images/circle-checked-fill.svg' : 'assets/images/close-circle-fill.svg'" alt="hide" class="valid-icons" />
            <span class="msg">Password must contain an uppercase letter.</span>
          </p>
          <p [ngClass]="{ 'success-message': !checkPasswordError('lowercase') }" class="error-message">
            <img [src]=" !checkPasswordError('lowercase') ? 'assets/images/circle-checked-fill.svg' : 'assets/images/close-circle-fill.svg'" alt="hide" class="valid-icons" />
            <span class="msg">Password must contain a lowercase letter.</span>
          </p>
          <p [ngClass]="{ 'success-message': !checkPasswordError('number') }" class="error-message">
            <img [src]=" !checkPasswordError('number') ? 'assets/images/circle-checked-fill.svg' : 'assets/images/close-circle-fill.svg'" alt="hide" class="valid-icons" />
            <span class="msg">Password must contain a number.</span>
          </p>
          <p [ngClass]="{ 'success-message': !checkPasswordError('specialCharacter') }" class="error-message">
            <img [src]=" !checkPasswordError('specialCharacter') ? 'assets/images/circle-checked-fill.svg' : 'assets/images/close-circle-fill.svg'" alt="hide" class="valid-icons" />
            <span class="msg">Password must contain a special character.</span>
          </p>
          <p *ngIf="passwordMaxLengthCheck()" class="error-message">
            <img [src]=" passwordMaxLengthCheck() ? 'assets/images/close-circle-fill.svg' : 'assets/images/circle-checked-fill.svg'" alt="hide" class="valid-icons" />
            <span class="msg">Password range must be less than 25.</span>
          </p>
        </ng-container>
      </div>
      
      <div class="confirm-check">
        <p>I agree to the Privacy Policy, Terms and Agreements and Terms of Service</p>
        <mat-checkbox class="example-margin" formControlName="confirm_check"></mat-checkbox>
      </div>
      <div class="confirm-check">
        <p>I agree to receive marketing notifications with offers and news</p>
        <mat-checkbox class="example-margin" formControlName="notifications_check"></mat-checkbox>
      </div>
      <button class="login-btn" type="submit" [disabled]="!signUpForm.valid || loading">Sign up</button>
      <ul class="errors">
      </ul>
    </form>
  </div>
</div>
